import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {ClinicianService} from '@infrastructure/clinician/clinician.service';
import {UserType} from '@infrastructure/generic-auth/user-type.enum';
import {LocalStorageKeys} from '@shared/utils/local-storage-keys.enum';
import {AdminService} from 'src/infrastructure/admin/admin.service';
import {OwnerService} from 'src/infrastructure/owner/owner.service';

export const userNotAuthenticatedGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean =>
{
    const ownerService = inject(OwnerService);
    const adminService = inject(AdminService);
    const clinicianService = inject(ClinicianService);
    const router = inject(Router);
    
    let isLoggedOut = false;

    if (route.data.type === UserType.OWNER)
    {
        isLoggedOut = !ownerService.owner() && (!localStorage.getItem(LocalStorageKeys.OWNER_ACCESS_TOKEN) || !localStorage.getItem(LocalStorageKeys.OWNER_REFRESH_TOKEN));
    }
    else if (route.data.type === UserType.ADMIN)
    {
        isLoggedOut = !adminService.admin() && (!localStorage.getItem(LocalStorageKeys.ADMIN_ACCESS_TOKEN) || !localStorage.getItem(LocalStorageKeys.ADMIN_REFRESH_TOKEN));
    }
    else if (route.data.type === UserType.CLINICIAN)
    {
        isLoggedOut = !clinicianService.clinician() && (!localStorage.getItem(LocalStorageKeys.CLINICIAN_ACCESS_TOKEN) || !localStorage.getItem(LocalStorageKeys.CLINICIAN_REFRESH_TOKEN));
    }

    if (!isLoggedOut)
    {
        router.navigateByUrl(`dashboard/${route.data.type}/profile`);
    }

    return true;
};
